import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { combineAll, DcBaseComponent } from '@datachain/ui-sdk/common';
import { concat, Observable, of } from 'rxjs';

@Component({
	selector: 'app-loader',
	templateUrl: './app-loader.component.html',
	styleUrls: ['./app-loader.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	inputs: ['isLoading', 'size'],
})
export class AppLoaderComponent extends DcBaseComponent implements OnInit {
	public vo$!: Observable<{
		isLoading: boolean;
		size: number;
	}>;

	public constructor() {
		super();
	}

	public ngOnInit(): void {
		super.ngOnInit();
		this.vo$ = combineAll({
			isLoading: concat(of(false), this.toObservable<boolean>('isLoading')),
			size: concat(of(40), this.toObservable<number>('size')),
		});
	}
}
